import { FC, InputHTMLAttributes } from "react";
import { RadioButton, RadioLabel } from "./Radio.styled";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
}

const Radio: FC<Props> = ({ name, ...rest }) => {
  return (
    <RadioLabel disabled={rest.disabled} data-testid="radio-label">
      <RadioButton {...rest} type="radio" data-testid="radio" />
      <span data-testid="radio-name">{name}</span>
    </RadioLabel>
  );
};

export default Radio;
